import { SchedulerSettingsTabs } from '@lp/features/Scheduler/components';
import {
  SSchedulerSettingsInputsTab,
  SSchedulerSettingsRulesTab,
} from '@lp/features/Scheduler/SchedulerSurgeonsSettings/components';
import {
  useLiSSetScheduleSettingsInputsMutation,
  useLiSSetScheduleSettingsRulesMutation,
  useSLiScheduleRegionsQuery,
  useSLiScheduleSettingsInputsQuery,
  useSLiScheduleSettingsRulesQuery,
} from '@/queries/resource/schedule';

type SchedulerLiSurgeonsSettingsProps = {
  scheduleBackPath: string;
};

export const SchedulerLiSurgeonsSettings = ({ scheduleBackPath }: SchedulerLiSurgeonsSettingsProps) => {
  return (
    <SchedulerSettingsTabs
      inputsTab={
        <SSchedulerSettingsInputsTab
          scheduleBackPath={scheduleBackPath}
          useSScheduleRegionsQuery={useSLiScheduleRegionsQuery}
          useSScheduleSettingsInputsQuery={useSLiScheduleSettingsInputsQuery}
          useSSetScheduleSettingsInputsMutation={useLiSSetScheduleSettingsInputsMutation}
        />
      }
      rulesTab={
        <SSchedulerSettingsRulesTab
          scheduleBackPath={scheduleBackPath}
          useSScheduleSettingsRulesQuery={useSLiScheduleSettingsRulesQuery}
          useSSetScheduleSettingsRulesMutation={useLiSSetScheduleSettingsRulesMutation}
        />
      }
    />
  );
};
